const REFUND_AMOUNT_NEEDS_HOLD = 10000000;

export { REFUND_AMOUNT_NEEDS_HOLD };
